import { SalesChannelCategoryMappingDetailPage } from "@/features/sales-channel-category-mapping/pages/SalesChannelCategoryMappingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-mapping/$id/detail",
)({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["masterdata.lookup"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryMappingDetailPage,
});
